// extracted by mini-css-extract-plugin
export default {"wrapper":"ScaleLink_wrapper__lHlZ1","image":"ScaleLink_image__kCQPx"};